var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',[_vm._v(_vm._s(_vm.headerTitle))]),_vm._t("slot_header_btns")],2)}
var staticRenderFns = []

export { render, staticRenderFns }